import { mdiTimerOutline } from '@lumapps/lumx/icons';
import { ConnectedWidgetProps } from '@lumapps/widget-base/components/Widget/ConnectedWidget';

import { LegacyWidgetSummaryProps } from './types';

export const CLASSNAME = 'block-summary';

export const WIDGET_SUMMARY_TYPE = 'summary';

export const WIDGET_SUMMARY_ICON = mdiTimerOutline;

/**
 * Excluding `text` from the queryKey because we don't want to re-fetch the widget in designer each time we update
 */
export const EXCLUDED_QUERY_KEY_WIDGET_PROPERTIES: ConnectedWidgetProps<LegacyWidgetSummaryProps>['excludedQueryKeyWidgetProperties'] =
    ['text'];
